import Meta from '@/components/common/Meta'

import StorageForWinterPage from '@/v2/components/pages/landing-pages/storage-for-winter-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/storage-for-winter-page'

interface StorageForWinterPageProps {}

const Page: React.FC<StorageForWinterPageProps> = () => {
  return (
    <>
      <Meta
        title={LANDING_PAGES_META_CONTENTS.storage_for_winter.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''}
        keywords={
          LANDING_PAGES_META_CONTENTS.storage_for_winter?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.storage_for_winter?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <StorageForWinterPage />
    </>
  )
}

export default Page
